import React from "react";
import { FiChevronLeft, FiSearch } from "react-icons/fi";
import { useLocation, useNavigate } from "react-router-dom";
import { routes } from "../helpers/Routes";
import NinjaEdgeLogo from "../assets/NinjaLogoSVG.svg";
import ACCULogoSVG from "../assets/ACCULogoSVG.svg";
import GenericLenderSVG from "../assets/GenericLenderSVG.svg";

const Header = ({ connectedToBank }) => {
  const navigate = useNavigate();
  const location = useLocation();
  // console.log(location.pathname);
  return (
    <>
      {location.pathname === routes.otp ||
      location.pathname === routes.login ? (
        <main
          className={`z-50 px-6 ${
            connectedToBank ? `py-2` : `py-[18px]`
          } mb-2 flex_itemC justify-between bg-white`}
        >
          <section>
            <div className="-ml-1" onClick={() => navigate(-1)}>
              <FiChevronLeft className="chevronLeftIcon" />
            </div>
          </section>
          <section className="mr-5 flex flex-grow items-center justify-center text-base text-primary font-semibold">
            <div className="">
              {connectedToBank ? (
                <img className="w-20 h-9" src={GenericLenderSVG} />
              ) : (
                <img className="w-32 h-4" src={NinjaEdgeLogo} />
              )}
            </div>
          </section>
        </main>
      ) : null}
      {location.pathname === routes.apply ||
      location.pathname === routes.connectBank ? (
        <main className="z-50 px-6 py-2 mb-2 flex_itemC justify-between bg-white">
          <section>
            <div className="-ml-1" onClick={() => navigate(-1)}>
              <FiChevronLeft className="chevronLeftIcon" />
            </div>
          </section>
          <section className="mr-5 flex flex-grow items-center justify-center text-base text-primary font-semibold">
            <div className="">
              <img className="w-20 h-9" src={GenericLenderSVG} />
            </div>
          </section>
        </main>
      ) : null}
      {location.pathname === routes.customerPortal ? (
        <>
          <main className="px-4 py-2 border-b flex_itemC justify-between">
            <section className="">
              {/* <div className="-ml-1 text-base font-semibold text-white">
                NINJA EDGE
              </div> */}
              <img className="w-32 h-4" src={NinjaEdgeLogo} />
              <div className="mt-1 text-greySecondary text-[9px] font-medium">
                Customer Portal
              </div>
            </section>
            <section className="">
              <img className="w-20 h-9" src={GenericLenderSVG} />
            </section>
          </main>
        </>
      ) : null}
    </>
  );
};

export default Header;
